import React from 'react'
import { ZERO } from 'shared/constants'
import { Menu as StyledMenu } from './styles'
import type { MenuProps } from './types'

const Menu: React.FC<MenuProps> = ({ topMenuMargin = ZERO, ...menuProps }) => (
  <StyledMenu topMenuMargin={topMenuMargin} {...menuProps} />
)

export default Menu
